import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Route, Router } from '@angular/router';

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent implements OnInit {

    constructor(private viewportScroller: ViewportScroller, private router: Router) {}

    public onClick(elementId: string): void {
        this.router.navigate(['/']);
        this.viewportScroller.scrollToAnchor(elementId);
    }

    ngOnInit() {
    }

    classApplied = false;
    toggleClass() {
        this.classApplied = !this.classApplied;
    }

}